import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TimerButtonService} from "../../services/timer-button.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GameServerMessage} from "../../interfaces/game-server-message";
import {TimerButtonState} from "../../enums/timer-button-state";
import {IconFont} from "../../enums/icon-font";
import {MqttClientService} from "../../services/mqtt-client.service";
import {OverlayService} from "../../overlay/overlay.service";
import {
  GameSessionControllerOverlayFooterComponent
} from "../../teacher/game-session-controller/game-session-controller-overlay-footer/game-session-controller-overlay-footer.component";
import {
  GameSessionControllerOverlayMainComponent
} from "../../teacher/game-session-controller/game-session-controller-overlay-main/game-session-controller-overlay-main.component";
import {TeacherGameSetupService} from "../../services/teacher-game-setup.service";
import {
  TeacherTimerStopDialogComponent
} from "../../teacher/teacher-timer-stop-dialog/teacher-timer-stop-dialog.component";
import {
  TeacherTimeStopDialogFooterComponent
} from "../../teacher/teacher-timer-stop-dialog/teacher-time-stop-dialog-footer/teacher-time-stop-dialog-footer.component";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-timer-button',
  templateUrl: './timer-button.component.html',
  styleUrls: ['./timer-button.component.scss']
})
export class TimerButtonComponent implements OnInit, OnDestroy {

  private readonly PAUSE_LABEL = "Pausiert";
  currentState = TimerButtonState.STOP;
  label = this.PAUSE_LABEL;

  @Input('iconRight') iconRight?: IconFont;
  @Input('has-game-controller') hasGameController? = false;

  constructor(
    private timerButtonService: TimerButtonService,
    private overlayService: OverlayService,
    private mqttClient: MqttClientService,
    private teacherGameSetupService: TeacherGameSetupService
  ) {}

  ngOnInit() {
    this.timerButtonService.subscribe(); // should be somewhere else in project
    this.timerButtonService.onUpdate().pipe(untilDestroyed(this)).subscribe((newValue) => {
      this.handleUpdate(newValue);
    });

    this.mqttClient.gameSessionTimeSubject.subscribe(response => {
      if (response === "start") {
        console.log('timer-button', response);
      } else if(response === "pause") {
        this.label = this.PAUSE_LABEL;
      }
    })
  }

  handleUpdate(msg: GameServerMessage): void {
    const newState: TimerButtonState = msg.state;

    // console.log("newState", newState);

    if(newState === TimerButtonState.PAUSE) {
      this.label = this.PAUSE_LABEL;
    } else if(newState === TimerButtonState.STOP) {
      if(this.hasGameController) {
        this.label = "00:00"
      } else {
        this.label = this.PAUSE_LABEL;
      }
    } else if(newState === TimerButtonState.PLAY) {
      const newTimerValue = msg.timerValue;
      this.setLabelByTimerValue(newTimerValue);
    }

    this.currentState = newState;
  }

  setLabelByTimerValue(time: number): void {
    if(time < 0) time = 0;
    const date = new Date(time * 1000);
    const hours = date.getHours() - 1;
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    this.label = `${(hours * 60 + minutes).toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    // console.log(new Date(time * 1000).toISOString());
    // this.label = new Date(time * 1000).toISOString().substring(14, 19);
  }

  openGameController() {
    if(this.hasGameController) {
      this.overlayService.openWindowOverlay({
        theme: "blue",
        title: "Spielzeit wählen",
        componentFooter: {
          component: GameSessionControllerOverlayFooterComponent,
          data: {
          }
        },
        componentMain: {
          component: GameSessionControllerOverlayMainComponent,
          data: {
          }
        }
      })
    }
  }

  stopGameSession() {

    if(this.currentState == TimerButtonState.PLAY && this.hasGameController) {
      this.overlayService.openWindowOverlay({
        title: "",
        theme: "blue",
        componentMain: {
          component: TeacherTimerStopDialogComponent,
          data: {}
        },
        componentFooter: {
          component: TeacherTimeStopDialogFooterComponent,
          data: {}
        }
      })
    }

  }

  ngOnDestroy() {
    console.warn("Timer button destroy");
    this.timerButtonService.unsubscribe();
  }

}
